import { useT } from '~/i18n';
import type { PlanState } from '../lib/plan';

/**
 * El cobro falló (past_due): el servidor pausó el envío y el plan sigue siendo
 * suyo. Va en coral, encima de todo, en el panel y en Perfil → Plan, para que
 * nadie vea «plan activo» mientras no sale ninguna postulación.
 *
 * El botón es un enlace normal al `pay_url` del servidor: ahí se crea la sesión
 * del portal de Stripe en el momento, y al volver se cobra y se reactiva solo.
 */
export default function PaymentPausedNotice({ plan }: { plan: PlanState }) {
  const t = useT('plan').paused;
  if (!plan.sending_paused || !plan.pay_url) return null;

  return (
    <div role="alert" className="alert alert-warning text-sm flex flex-col items-start gap-2">
      <span>
        <strong>{t.title}.</strong> {t.body}
      </span>
      <a href={plan.pay_url} className="btn btn-primary btn-sm">
        {t.cta}
      </a>
    </div>
  );
}
